import { render, staticRenderFns } from "./UserRegister.vue?vue&type=template&id=f52c7042&scoped=true"
import script from "./UserRegister.vue?vue&type=script&lang=js"
export * from "./UserRegister.vue?vue&type=script&lang=js"
import style0 from "./UserRegister.vue?vue&type=style&index=0&id=f52c7042&prod&lang=css"
import style1 from "./UserRegister.vue?vue&type=style&index=1&id=f52c7042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52c7042",
  null
  
)

export default component.exports